// Shared cap behaviour for the multi-location picker, used by both the hook
// (chips + map) and the search-sheet content so the two can't drift.
//
// maxLocations === 1 → replace (selecting a new zone swaps the current one).
// maxLocations  > 1 → hard cap (once full, adding is blocked, not a swap).

export function isMaxLocationsReached(
  count: number,
  maxLocations?: number,
): boolean {
  return !!maxLocations && maxLocations > 1 && count >= maxLocations;
}

/**
 * The next codes after toggling `code`, or `null` when the toggle is blocked
 * (a multi-cap is full and `code` is a new addition). Deselecting is always
 * allowed.
 */
export function toggleCodeWithCap(
  codes: string[],
  code: string,
  maxLocations?: number,
): string[] | null {
  if (codes.includes(code)) return codes.filter((c) => c !== code);
  if (maxLocations && codes.length >= maxLocations) {
    if (maxLocations === 1) return [...codes.slice(1), code];
    return null;
  }
  return [...codes, code];
}

/**
 * Clamp a map selection to the cap: single keeps the last picked, a multi-cap
 * rejects an over-limit selection (keeps the current one) rather than swapping.
 */
export function clampMapSelection(
  current: string[],
  next: string[],
  maxLocations?: number,
): string[] {
  if (!maxLocations) return next;
  if (maxLocations === 1) return next.slice(-1);
  if (next.length > maxLocations) return current;
  return next;
}
